(function () {
  function perInstallmentCents(priceCents, count) {
    const n = count > 0 ? count : 4;
    return Math.round(Number(priceCents) / n);
  }

  function updateAmount(el, priceCents, count) {
    if (!el || priceCents == null || typeof theme === 'undefined') return;
    const per = perInstallmentCents(priceCents, count);
    const format = theme.shopSettings && theme.shopSettings.moneyFormat;
    const formatted = theme.Currency.formatMoney(per, format) || '';
    el.textContent = formatted;
    const major = (per / 100).toFixed(2);
    el.setAttribute('bucks-init', major);
    el.setAttribute('bucks-original', formatted);
    if (window.Shopify && Shopify.currency && Shopify.currency.active) {
      el.setAttribute('bucks-currency', Shopify.currency.active);
    }
    el.setAttribute('bucks-current', formatted);
  }

  function basisCentsForVariant(root, variant) {
    if (!root || !variant) return null;
    const script = root.querySelector('script.pay-later__basis-by-variant');
    if (!script) return variant.price;
    try {
      const map = JSON.parse(script.textContent);
      const raw = map[String(variant.id)];
      if (raw != null && raw !== '') return Number(raw);
    } catch (e) {
      /* ignore */
    }
    return variant.price;
  }

  function syncRoots(sectionId, variant) {
    const roots = document.querySelectorAll(
      '.pay-later[data-pay-later-root][data-section-id="' + sectionId + '"]'
    );
    roots.forEach((root) => {
      if (!variant || variant.available === false) {
        root.classList.add('hidden');
        return;
      }
      root.classList.remove('hidden');
      const count = parseInt(root.getAttribute('data-installment-count'), 10) || 4;
      const el = root.querySelector('[data-pay-later-amount]');
      const basis = basisCentsForVariant(root, variant);
      updateAmount(el, basis, count);
    });
  }

  function onVariantChange(event) {
    if (!event || !event.data) return;
    syncRoots(event.data.sectionId, event.data.variant);
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
  });
})();
